<script lang="ts" setup>
const props = defineProps({
  office: {
    type: Object,
    required: true
  },
  cities: {
    type: Object,
    required: true
  },
})

const days = [
  {
    key: 'monday',
    label: 'Mo'
  },
  {
    key: 'tuesday',
    label: 'Di'
  },
  {
    key: 'wednesday',
    label: 'Mi'
  },
  {
    key: 'thursday',
    label: 'Do'
  },
  {
    key: 'friday',
    label: 'Fr'
  },
  {
    key: 'saturday',
    label: 'Sa'
  }
]

function getDomainFromUrl(url: string) {
  try {
    const { hostname } = new URL(url)
    return hostname
  } catch {
    return null
  }
}

function getLocaleTimeString (dateString: string): string {
  const date = new Date(dateString)

  return date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
}

function stripNonNumbersFromString(string: string): string {
  return string.replace(/\D/g, '')
}

function getCity (office) {
  return props.cities.find(city => city._id === office.cityId)
}
</script>

<template lang="pug">
.office-information-card.bg-slate-50.drop-shadow-xl.p-4.pr-6.rounded-2xl.pt-10.w-full(class="w-auto")
  .mac-browser-headline.absolute.h-8.flex.gap-2.top-0.py-4.left-0.pl-5
    .red
    .yellow
    .green
  Nuxt-Link(
    v-if="getCity(office)"
    :to="`/stadt/${getCity(office).slug}`"
    :title="`Fahrzeug abmelden in der Zulassungsstelle ${office.name}`"
  )
    h3.text-2xl.font-bold.mb-6 Zulassungsstelle {{ office.name }}
  .grid.grid-cols-1.gap-10(class="md:grid-cols-2")
    .contact.grid.grid-cols-1.gap-8
      .address
        img.icon.w-auto(
          src="/images/icons/location-outline.svg"
          alt="Icon: Standort"
          loading="lazy"
        )
        p.title Adresse
        p {{ office.address.street }}
        p {{ office.address.postalCode }} {{ office.address.city }}
      .phone(v-if="office.address.phone")
        img.icon.w-auto(
          src="/images/icons/phone.svg"
          alt="Icon: Telefon"
          loading="lazy"
        )
        p.title Telefon

        p
          a(:href="`tel:${stripNonNumbersFromString(office.address.phone)}`").text-sky-700
            | {{ office.address.phone }}
      .email(v-if="office.address.email")
        img.icon.w-auto(
          src="/images/icons/mail.svg"
          alt="Icon: E-Mail"
          loading="lazy"
        )
        p.title E-Mail
        p
          a(:href="`mailto:${office.address.email}`").text-sky-700
            | {{ office.address.email }}
      .website
        img.icon.w-auto(
          src="/images/icons/internet.svg"
          alt="Icon: Internet"
          loading="lazy"
        )
        p.title Website
        p
          nuxt-link(:href="office.website").text-sky-700
            | {{ getDomainFromUrl(office.website) }}
    
    .hours
      div
        img.icon.w-auto(
          src="/images/icons/timer.svg"
          alt="Icon: Öffnungszeiten"
          loading="lazy"
        )
        p.title Öffnungszeiten

        .flex.py-1(v-for="day in days")
          span.day.w-10 {{ day.label }}
          client-only
            div(v-if="office.openingHours[day.key].hours.length > 0")
              p(v-for="(hour, index) in office.openingHours[day.key].hours")
                | {{ getLocaleTimeString(office.openingHours[day.key].hours[index].start) }} Uhr - {{ getLocaleTimeString(office.openingHours[day.key].hours[index].end) }} Uhr

            p(v-else) geschlossen

</template>

<style lang="sass">
.office-information-card
  .mac-browser-headline
    .red, .yellow, .green
      @apply w-2 h-2 rounded-full

    .red
      background-color: #e11d48

    .yellow
      background-color: #fbbf24

    .green
      background-color: #10b981

  .contact, .hours
    > div
      @apply pl-10 relative

  .title
    @apply text-xl font-bold uppercase mb-3
    line-height: 24px

  img.icon
    @apply absolute left-0 top-0 h-6
</style>
